import styled from 'styled-components';

// hard coded colors for printing are ok

export const PrintDiv = styled.div`
  font-size: 14px;
  border-color: #2e2e2e;
  margin-top: 5px;
  padding: 0px 10px 0px 20px;
  @media print {
    color: ${(props) => props.theme.palette.common.black};
  }
`;

export const NoteDiv = styled.div`
  padding: 10px;
  @media print: {
    max-width: 700px;
    border-color: black !important;
    color: ${(props) => props.theme.palette.common.black};
  }
  white-space: pre-wrap;
`;
export const ProgressNotesPrintDiv = styled.div`
  background-color: ${(props) => props.theme.palette.background.paper};
  color: ${(props) => props.theme.palette.text.primary};
  @media print {
    page-break-after: always;
    color: ${(props) => props.theme.palette.common.black};
    background-color: ${(props) => props.theme.palette.common.white};
  }
`;
export const PageBreak = styled.div`
  @media print {
    visibility: hidden;
  }
`;

export const TitlePrint = styled.div`
  margin: 20px;
  border: 1px solid;
  display: flex;
  justify-content: center;
  font-weight: 600;
  font-size: 16px;
`;

export const NotePSODiv = styled.div<{ standingOrder: any }>`
  ${(props) =>
    props.standingOrder
      ? 'border: solid black 2.5px; margin-bottom: 1rem; padding: .5rem;'
      : ''}
  @media print {
    border: none !important;
  }
`;

export const NoteWrapperDiv = styled.div<{ displayPSOContent: boolean }>`
  ${(props) => (props.displayPSOContent ? 'display: none;' : 'display: block;')}

  @media print {
    display: none !important;
  }
`;
